import { FETCH_CUSTOMER } from '../actions/type';

export default (state = {}, action) => {
    switch(action.type) {
        case FETCH_CUSTOMER:
            return { ...action.payload }
        default:
            return state;
    }
}